import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import CodeExample from "../../partials/content/CodeExample";
import { createSupport,getUserByToken,signedUrlBanner,s3Upload,getFile } from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import ReactS3Uploader from "react-s3-uploader"
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import FileUploadPreview from './FileUploadPreview';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import {  format } from 'date-fns'
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class SupportForm extends React.Component {
  state = {
    fields:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    showImage:false,
    showText:false,
    attachments:[],
    statusMap:{},
  }



  handleDateChange = (date: Date | null) => {
    this.setState({selDate:date});
  };

  handleZipChange = (e) => {

    const {setFieldValue} = this.props;
    console.log(e.target.name);
    console.log(e.target.value);

    setFieldValue("country", "USA");
    setFieldValue("state", "MA");
    setFieldValue("city", "Boston");
  };

  handleSubmit = (files, allFiles) => {
    console.log(files.map(f => f.meta))
    allFiles.forEach(f => f.remove())
  }

getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    console.log(params);
    signedUrlBanner({ params })
    .then(data => {
      //callback(data.data);
      //console.log(data.data);
     // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
      s3Upload(data.data.signedUrl,file)
      .then(response => response.data)
        .then((data) => {
         
            console.log(data);
         });
    })
    .catch(error => {
      //console.log(error);
    });

}

 getUploadParams = async  ({ file, meta: { name } }) => {

  //console.log(this.state.patient.id);
  //let id = this.state.patient.id;
  let id=this.state.user.userId + '/'+ format(new Date(),"MM-dd-yyyy-HH-mm");
  let path = "support-ticket";
  //name = format(new Date(),"MM-dd-yyyy-HH-mm") + "-"+ name;
  let url ="";
     await signedUrlBanner({ path,name,id })
    .then(data => {
      url = data.data.signedUrl;
      
    })
    //console.log("url 2===="+url);
    //console.log("url===="+ url);
    console.log(file);
    return { body: file, meta: {}, url:  url,method:'PUT'}
  }

   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
        //console.log(f.meta)
      //))
  }

  handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
    //let id = this.state.patient.id;
    const fileId = meta.id;
    console.log("meta::::::",meta);
    let id=this.state.user.userId + '/' + format(new Date(),"MM-dd-yyyy-HH-mm");
    if(status=="done")
    {
      let attachments = this.state.attachments;
      attachments.push({fileName:meta.name,fileType:meta.type,originalFileKey:'support-ticket/'+id+'/'+meta.name,originalFileSize:meta.size})
      this.setState({imagePath: 'support-ticket/'+id+'/'+meta.name,attachments:attachments})
     /* addFile(id,meta.name,meta.size,meta.type).then(response => response.data)
        .then((data) => {
            getPatientById(id).then(response => response.data)
          .then((data) => {
            this.setState({ patients: data })
            //console.log(data);
           });
        });*/

        this.setState({
					statusMap: {
						...this.state.statusMap,
						[fileId]: "verified"
					}
					});
    }
  }



constructor(props)
{
  super(props);
    this.state = {
      menu: false,
      fields:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      accounts:[],
      showText:false,
      showImage:false,
      expiryDate:null,
      publishDate:null,
      attachments:[],
      statusMap:{},

    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  
  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    getUserByToken().then(response => response.data)
    .then((data) => {
      this.setState({ user: data[0] })
      console.log(data);
     });
    
     
  }

  reset(){

  }

handleRadioChange=(e)=>
{
    console.log(e.currentTarget.value);
    let value = e.currentTarget.value;
    if(value=="text")
    {
      this.setState({showImage:false,showText:true,bannerType:value});

    }
    else
    {
       this.setState({showImage:true,showText:false,bannerType:value});
    }
}
  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }

    
  
} 



  render() {
    
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
     const showImage = this.state.showImage? "block" : "none";
     const showText = this.state.showText ? "block" : "none" ;

    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
          {this.state.user!==null && this.state.user!==undefined && 
           <Formik
                  initialValues={{
                    name: this.state.user.firstName + ' ' + this.state.user.lastName,
                    roleName: this.state.user.role,
                    accountName: this.state.user.account,
                    subject:'',
                    description:'',
                   
                    
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.subject) {
                      errors.subject = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.description) {
                      errors.description = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
         

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue,resetForm}) => {
                    this.setState({loading:true});
                   
                    createSupport(
                      this.state.user.userId, 
                      this.state.user.roleKey, 
                      this.state.user.accountKey,
                      this.state.attachments,
                      values.subject,
                      values.description,
                      this.state.user.account,
                      this.state.user.role
                      )
                      .then(resp => {
                        //props.register(accessToken);
                       // resetForm();
                        //Dropzone.removeAllFiles();
                        this.setState({status:true, attachments:[],
                        statusMessage:'Ticket raised successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
          
                      
        	
      		<CodeExample beforeCodeTitle="Support Form">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           		   			
		   			<div className="row">
		   		            
                      <div className={"col-12"} >
                        <TextField
                          margin="normal"
                          label="Name"
                          className="kt-width-full"
                          id="name"
                          disabled={true}
                          name="name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.name}
                          helperText={touched.name && errors.name}
                          error={Boolean(touched.name && errors.name)}
                        />
                      </div>  

                      <div className={"col-12"} >
                        <TextField
                          margin="normal"
                          label="Role"
                          className="kt-width-full"
                          id="roleName"
                          name="roleName"
                          disabled={true}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.roleName}
                          helperText={touched.roleName && errors.roleName}
                          error={Boolean(touched.roleName && errors.roleName)}
                        />
                      </div>  

                      
                     

                      <div className={"col-12"} >
                        <TextField
                          margin="normal"
                          label="Business Entity"
                          className="kt-width-full"
                          id="accountName"
                          name="accountName"
                          disabled={true}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.accountName}
                          helperText={touched.accountName && errors.accountName}
                          error={Boolean(touched.accountName && errors.accountName)}
                        />
                      </div>    

                      <div className={"col-12"} >
                        <TextField
                          margin="normal"
                          label="Subject"
                          className="kt-width-full"
                          id="subject"
                          name="subject"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.subject}
                          helperText={touched.subject && errors.subject}
                          error={Boolean(touched.subject && errors.subject)}
                        />
                      </div>    

                      <div className="col-12">
                          <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          id="description"
                          name="description"
                          onBlur={handleBlur}
                          multiline
                          rows={4}
                          variant="outlined"
                          onChange={handleChange}
                          value={values.description}
                          helperText={touched.description && errors.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                      </div>      

                      <div className="col-12" >
                        <Dropzone
                        accept="image/*,.docx,.doc,.xlsx,.xls,.pdf,.txt"
                        PreviewComponent={(props) => (
                                            <FileUploadPreview
                                            {...props}
                                            customStatus={this.state.statusMap[props.meta.id]}
                                            />)}
                        onChangeStatus={this.handleChangeStatus}
                        getUploadParams={this.getUploadParams}
                        inputContent="Drag your documents"
                        maxFiles={5}
                        maxSizeBytes={5242880}
                        multiple={true}
                        canCancel={false}
                        styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
                       />
                      </div>  

                          
		   			  </div>
              
				   
			    </div>
		    </div>
		    </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Raise Ticket
                        </button>
                       
                      </div>
       </form>
            )}
            </Formik>
          }

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(SupportForm));

